import { ApolloLink } from "@apollo/client";
import { decryptPayload } from "../encryption";

export const decryptLink = new ApolloLink((operation, forward) => {
  return forward(operation).map((response) => {
    try {
      const context = operation.getContext();
      const isEncrypted = Number(context.headers?.is_encrypt_response) === 1;

      if (!isEncrypted || context.bypassEncryption) {
        return response;
      }

      if (response.data) {
        response.data = decryptPayload(response.data);
      }

      return response;
    } catch (error) {
      console.error("Error in decryptLink: ", error);
      throw error;
    }
  });
});
